import { el } from 'redom';

import { stringToSVG } from 'utilities';

import uploadPictureIndicatorString from 'assets/images/upload-picture-indicator.svg?raw';

const uploadPictureIndicator = stringToSVG(uploadPictureIndicatorString);

class FileInputRenderer {

  constructor() {

    this.input = null;

    this.uploadButton = null;

    this.el = el('.form-editor-text-input-renderer', [
      this.renderInput()
    ]);

  }

  // <div class="file-drop-zone-main">
  // <div class="drop-zone-content">
  // <label class="drop-zone-message-label">Drag your logo here or upload via the button below</label>
  // <p class="file-size-information-label">Max file size: 5mb</p>
  // <button type="button" class="file-upload-button-link startup-themed-button">Import a .jpg or .png file<input type="file" class="file-input"></button>
  // </div>
  // </div>

  renderInput() {

    this.uploadButton = el('button.file-upload-button-link', {
      class: 'startup-themed-button',
      type: 'button'
    }, 'Upload a file');

    this.input = el('.file-drop-zone-main', [
      el('.drop-zone-image-container', [
        uploadPictureIndicator.cloneNode(true)
      ]),
      el('.drop-zone-content', [
        el('label.drop-zone-message-label', 'Drag your file here or upload via the button below'),
        el('p.file-size-information-label', 'Max file size: 5mb'),
        this.uploadButton
      ])
    ]);

    return this.input;

  }

  update(options) {

    this.uploadButton.textContent = options.buttonText;

  }

}

export default FileInputRenderer;